export default __webpack_public_path__ + "static/media/ble1.06015b7f.png";